import { QRCodeSVG } from 'qrcode.react'
import type { CSSProperties } from 'react'
import { cn } from '~/shared/lib/utils'
import { type FlyerContent, PRINT_LOGO_SRC } from './flyer-content'

export function PrintFlyer({
  content,
  className,
  style,
}: {
  content: FlyerContent
  className?: string
  style?: CSSProperties
}) {
  return (
    <div
      style={style}
      className={cn(
        '@container overflow-hidden bg-print-paper text-center text-print-ink',
        className,
      )}
    >
      <div className="flex size-full flex-col items-center px-[12cqw] pt-[12cqw] pb-[10cqw]">
        <h1 className="line-clamp-3 shrink-0 font-serif text-[9cqw] leading-[1.12] font-semibold break-words">
          {content.title}
        </h1>
        <p className="mt-[3cqw] shrink-0 text-[4.6cqw] leading-snug font-medium">
          {content.headline}
        </p>
        <div className="flex flex-1 flex-col items-center justify-center gap-[3cqw] py-[5cqw]">
          <QRCodeSVG value={content.url} marginSize={0} className="block size-[56cqw]" />
          <p className="text-[2.8cqw] font-semibold tracking-[0.16em] uppercase">
            {content.fineprint}
          </p>
          {content.code && (
            <p className="font-mono text-[3.2cqw] tracking-[0.12em] text-print-ink/70">
              {content.codeLabel} {content.code}
            </p>
          )}
        </div>
        <img src={PRINT_LOGO_SRC} alt="" className="h-[8cqw] w-auto" />
      </div>
    </div>
  )
}
